import { useState } from "preact/hooks";
import { t } from "../i18n";
import { LINUX_UDEV_INSTALL, WINDOWS_DRIVER_URL, checkBrowser, driverGuidanceKey, type BrowserCheck as Check } from "../platform/browser";

export function currentBrowserCheck(): Check {
  return checkBrowser({ ua: navigator.userAgent, platform: navigator.platform, hasUsb: "usb" in navigator, secureContext: window.isSecureContext });
}

export function BrowserCheckPanel({ check }: { check: Check }) {
  const [copied, setCopied] = useState(false);
  const osName = { windows: "Windows", macos: "macOS", linux: "Linux", chromeos: "ChromeOS", android: "Android", ios: "iOS", other: "?" }[check.os];
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(LINUX_UDEV_INSTALL);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      /* clipboard denied; the text is selectable anyway */
    }
  };
  return (
    <section aria-labelledby="browser-h">
      <h3 id="browser-h">{t("browser.heading")}</h3>
      {check.ok ? (
        <p class="notice ok" role="status">{t("browser.ok")}</p>
      ) : (
        <ul class="notice danger" role="alert">
          {!check.chromium && <li>{t("browser.not_chromium")}</li>}
          {!check.desktop && <li>{t("browser.not_desktop")}</li>}
          {check.chromium && check.desktop && !check.webusb && <li>{t("browser.no_webusb")}</li>}
          {!check.secureContext && <li>{t("browser.insecure")}</li>}
        </ul>
      )}
      <h3>{t("drivers.heading", { os: osName })}</h3>
      <p>{t(driverGuidanceKey(check.os))}</p>
      {check.os === "windows" && (
        <p>
          <a href={WINDOWS_DRIVER_URL} target="_blank" rel="noopener noreferrer">{t("drivers.windows_link")}</a>
        </p>
      )}
      {check.os === "linux" && (
        <div>
          <pre tabIndex={0}>{LINUX_UDEV_INSTALL}</pre>
          <button type="button" onClick={() => void copy()}>{copied ? t("common.copied") : t("drivers.copy_rule")}</button>
        </div>
      )}
    </section>
  );
}
